/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 318);
/******/ })
/************************************************************************/
/******/ ({

/***/ 24:
/***/ (function(module, exports) {

// Global namespace
window.RS = window.RS || {};

// all utilities
RS.Utils = RS.Utils || {};

// Basket Module
RS.Modules = RS.Modules || {};


/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(319);
module.exports = __webpack_require__(329);


/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(24);
__webpack_require__(320);
__webpack_require__(60);
__webpack_require__(321);
__webpack_require__(322);
__webpack_require__(323);
__webpack_require__(324);
__webpack_require__(325);
__webpack_require__(326);
__webpack_require__(327);
__webpack_require__(328);


/***/ }),

/***/ 320:
/***/ (function(module, exports) {

// Reusable AJAX functionalities

 (function () {
  // called ajax request by passing any custom url
  RS.Utils.AjaxService = {
    // AjaxService object's method to make ajax request which accepts a url
    // and callback function timeout if not supplied sets to 10 sec
    processXHR: function (url, type, timeoutwait, successCallback, data, errorCallback, global) {
      return $.ajax({
        headers: {
          Accept: 'application/json',
          Authorization: 'Basic TW9iaWxlV2ViOmVtcHR5',
        },
        type: type,
        url: url,
        data: data,
        success: successCallback,
        timeout: (typeof timeoutwait !== 'undefined' ? timeoutwait : 10000),
        error: errorCallback,
        global: global !== undefined ? global : true,
      });
    },
    deferreds: [],
  };
}());


/***/ }),

/***/ 321:
/***/ (function(module, exports) {

// reusable cookies functionality
(function () {
  /* eslint-disable */
  RS.Utils.LocalStorage = {

    expiresInDays: 30,

    isExpired: function (lastUpdateInMs) {
      var _diffdays = Math.ceil(Math.abs(new Date().getTime() - lastUpdateInMs) / 86400000);
      return (_diffdays > this.expiresInDays);
    },

    isAvailable: function () {
      var _storage;
      var _result;
      try {
        _storage = localStorage.setItem('uid', 'uid');
        _result = localStorage.getItem('uid') === 'uid';
        localStorage.removeItem('uid');
        return _result;
      } catch (e) {
        return false;
      }
    },

    isSessionStorageAvailable: function () {
      var _storage;
      var _result;
      try {
        _storage = sessionStorage.setItem('uid', 'uid');
        _result = sessionStorage.getItem('uid') === 'uid';
        sessionStorage.removeItem('uid');
        return _result;
      } catch (e) {
        return false;
      }
    },

    getItemFromSessionStorage: function (cname) {
      return this.isSessionStorageAvailable() ? sessionStorage.getItem(cname) : null;
    },

    getItem: function (cname) {
      return (this.isAvailable() && !this.isExpired()) ? localStorage.getItem(cname) : null;
    },

    getItemWithoutExpiry: function (cname) {
      return this.isAvailable() ? localStorage.getItem(cname) : null;
    },

    setItem: function (cname, objData) {
      if (RS.Utils.LocalStorage.isAvailable()) {
        localStorage.setItem(cname, objData);
      }
    },

    setItemInSessionStorage: function (cname, objData) {
      if (RS.Utils.LocalStorage.isSessionStorageAvailable()) {
        sessionStorage.setItem(cname, objData);
      }
    },
  };
}());


/***/ }),

/***/ 322:
/***/ (function(module, exports) {

(function () {
/*
    This module covers dynamic data updates on the header which includes
    user login status, basket and adding listeners for TN page
    Get basket data from local storage
    Fetch running total
    Update dynamic data
  */

  RS.Modules.UserStatus = {

    refLogInOut: null,
    refRegister: null,
    refWelcome: null,
    refNotYou: null,
    refSecondaryNavList: null,
    refCredit: null,
    refMyAccountMenuList: null,
    refBasketContainer: null,
    refBasketQty: null,
    refBasketLink: null,
    refBasketAmt: null,
    refPhone: null,
    pollingFrequency: 5000,
    timeoutID: null,
    isNewHeader: null,
    isNewFooter: null,

    init: function () {
      this.refLogInOut = $('#js-logInOut');
      this.refRegister = $('#js-register');
      this.refWelcome = $('#js-welcome');
      this.refNotYou = $('#js-notYou');
      this.refSecondaryNavList = $('#js-secondaryNav');
      this.refCredit = $('#js-myAccount > li:last-child');
      this.refMyAccountMenuList = $('#js-myAccount');
      this.refBasketContainer = $('.js-basket');
      this.refBasketQty = $('#js-basketQty');
      this.refBasketLink = $('.js-basket a');
      this.refBasketAmt = $('#js-basketAmt');
      this.refPhone = $('.phone');
      this.isNewHeader = $('header');
      this.isNewFooter = $('footer');
      this.updateBasket();
      this.runningTotal();
      this.dynamicData();
      this.basketListener();
    },

    checkLogStatus: function(){
      var _logStatus = RS.Utils.Cookies.getCookie('loginStatus');
      return ($.isNumeric(_logStatus));
    },

    updateBasket: function () {
      var _cartId = RS.Utils.Cookies.getCookie('cart');
      var _basket;
      try {
        _basket = JSON.parse(RS.Utils.LocalStorage.getItem('minibasket'));
      } catch (e) {
        _basket = null;
      }
      if (_cartId != null && _basket != null) {
        this.refBasketQty.text(_basket.prdqty);
        this.refBasketAmt.text(_basket.totalamt);
      }
    },

    runningTotal: function () {
      var _url = '/web/miniBasketRunningTotal.html';
      var _type = 'GET';
      RS.Utils.AjaxService.processXHR(_url, _type, 5000, RS.Modules.UserStatus.updateRunningTotal);
    },

    updateRunningTotal: function (data) {
      var _basket = data.split('||');
      var objUS = RS.Modules.UserStatus;
      if (_basket != null && _basket[0] === 'stable') {
        // update QTY, Amount and Title
        objUS.refBasketQty.text(_basket[1]);
        objUS.refBasketAmt.text(_basket[2]);
        objUS.updateTitle(_basket[1]);
        // only when there are items
        objUS.refBasketContainer.attr('data-loggedin', (_basket[1] > 0));
        // store data
        objUS.lsStorage(_basket[1], _basket[2]);
        // clear timeout
        if (objUS.timeoutID != null) {
          window.clearTimeout(objUS.timeoutID);
          delete objUS.timeoutID;
        }
      } else {
        if (_basket[0] === 'unstable') {
          // keep polling until stable
          objUS.timeoutID = window.setTimeout(objUS.runningTotal, objUS.pollingFrequency);
        }
      }
    },

    /*Update the basket title on the page */
    updateTitle: function (items) {
      var titleText;
      // check that page has basket title var
      if (typeof BasketTitle !== 'undefined') {
        if (items > 0) {
          titleText = items + ' ' + BasketTitle.hasitems;
        } else {
          titleText = BasketTitle.empty;
        }
        RS.Modules.UserStatus.refBasketLink.attr('title', titleText);
      }
    },

    lsStorage: function (qty, amt) {
      var _basketData = {
        cartid: RS.Utils.Cookies.getCookie('cart'),
        prdqty: qty,
        totalamt: amt,
        lastupd: new Date().getTime(),
      };
      RS.Utils.LocalStorage.setItem('minibasket', JSON.stringify(_basketData));
    },

    dynamicData: function () {
      // only if loginStatus is available
      if(!this.checkLogStatus())
        return;
      var _url = '/web/services/header/getDynamicData';
      var _type = 'GET';
      RS.Utils.AjaxService.processXHR(_url, _type, 5000, this.updateDynamicData);
    },

    updateDynamicData: function (data) {
      var objUS = RS.Modules.UserStatus;
      // Remove credit account if set to not display
      if (data.credAccount) {
          objUS.refCredit.toggle(data.credAccount.display);
      }
      // Update logged in
      if (data.loggedInfo && data.loggedInfo.loggedIn) {
        objUS.refLogInOut.text(data.loggedInfo.logoutLabel)
          .attr('title', data.loggedInfo.logoutLabel)
          .attr('href', data.loggedInfo.logoutLink);

        objUS.refMyAccountMenuList.append($('<li class="logStatus"><a href="' +
          data.loggedInfo.logoutLink + '" class="btn">' +
          data.loggedInfo.logoutLabel + '</a></li>'));
      }
      // Update 'remember me' text
      if (objUS.isNewHeader.length > 0 &&
        data.rememberMe && data.rememberMe.selected) {
        objUS.refNotYou.html('<a href="' + data.rememberMe.notMeLink + '">' +
          data.rememberMe.notMeLabel + '</a>').show();
      }
      // Update Name
      if (data.names) {
        objUS.refRegister.hide();
        if (objUS.isNewHeader.length > 0) {
          objUS.refWelcome.text(data.names.greeting + ' ' + data.names.foreName).show();
        }
      }
      // Update details for PM user
      if (data.userType === 'PM' && data.pmUser.enabled) {
        objUS.updatePMDtls(objUS, data);
      }
      //Update details for PUNCH_OUT user
      if (data.userType === 'PUNCH_OUT' && data.names) {
        objUS.refLogInOut.hide();
        objUS.refWelcome.text(data.names.greeting + ' ' + (data.names.eprocDisplayName ? data.names.eprocDisplayName : '')).show();
      }
    },

    updatePMDtls: function (objUS, data) {
      // Add additional link for PM user in header if not present
      if (objUS.refSecondaryNavList.length > 0 && objUS.refSecondaryNavList.find('a[href="' + data.pmUser.link + '"]').length == 0 ) {
        objUS.refSecondaryNavList.append($('<li></li>')
          .html($('<a></a>')
            .attr('href', data.pmUser.link)
            .text(data.pmUser.label)));
      }

      // Update phone number in footer
      if (objUS.refPhone.length > 0) {
        objUS.refPhone.text(data.pmUser.helpline);
      }
    },

    basketListener: function () {
      // Listen for the reloadMiniBasket custom event sent by Angular, when its received, hide #js-basketAmt  & then call getRunningTotal to update the totals
      this.refBasketQty.on('reloadMiniBasket', function () {
        setTimeout(RS.Modules.UserStatus.runningTotal, RS.Modules.UserStatus.pollingFrequency);
      });
      this.refBasketQty.on('reloadMiniBasketAndSendToAnalytics', function (event) {
        setTimeout(RS.Modules.UserStatus.runningTotal, RS.Modules.UserStatus.pollingFrequency);
        RS.Modules.Analytics.publishAddToCartEvent(event.detail.rsStockNumber,
          event.detail.quantity, event.detail.pageName);
      });
    },

  };
}());

(function () {
  RS.Modules.UserStatus.init();
}());


/***/ }),

/***/ 323:
/***/ (function(module, exports) {

(function () {
  /* eslint-disable */
  RS.Modules.SearchBox = {
    BLACK:'#000000',
    refSearchTerm: null,
    refSearchForm: null,
    refMpnSearchCheckbox: null,
    refMpnSearchCheckboxIcon: null,
    MPN_SEARCH_CHECKED: 'MPN_SEARCH_CHECKED',
    REDIRECT: 'Redirect',

    check: function (event) {
      // Remove * sign from the search box
      var _searchValue = (RS.Modules.SearchBox.refSearchTerm.val()).replace(/\*/g, '');

      if (_searchValue.length < RS.Modules.SearchBox.minLength() || _searchValue === searchConfig.searchDefaultText) {
        // change this to bootstrap modal in future
        window.alert(RS.Modules.SearchBox.searchLengthMessage());
        RS.Modules.SearchBox.refSearchTerm.focus();
        event.preventDefault();
      } else {
        RS.Modules.Analytics.addDeferredSearchEvent('header', _searchValue);
      }
    },

    minLength: function () {
      return (typeof(searchConfig.searchTermMinLength) !== 'undefined') ? searchConfig.searchTermMinLength : 2;
    },

    repopulateSearchTerm: function() {
      var digitalData = (((rs || {}).web || {}).digitalData || {});
      var searchTerm = digitalData.search_keyword || null;
      var searchTermCorrected = digitalData.search_keyword_spell_corrected || null;
      var searchResponseAction = digitalData.search_response_action || null;

      if (searchResponseAction === RS.Modules.SearchBox.REDIRECT) {
        return;
      }

      if (searchTermCorrected) {
        this.refSearchTerm.val(searchTermCorrected);
        this.refSearchTerm.css('color', RS.Modules.SearchBox.BLACK);
      } else if (searchTerm) {
        this.refSearchTerm.val(searchTerm);
        this.refSearchTerm.css('color', RS.Modules.SearchBox.BLACK);
      }
    },

    searchLengthMessage: function () {
      return (typeof(searchLengthMessage) !== 'undefined') ? searchLengthMessage : 'Please enter a value';
    },

    init: function (elmSearchForm, elmSearchTerm) {
      this.refSearchForm = $(elmSearchForm);
      this.refSearchTerm = $(elmSearchTerm);
      if (this.refSearchTerm.length > 0 && this.refSearchForm.length > 0) {
        this.refSearchForm.submit(RS.Modules.SearchBox.check);
      }
    },

    bindMpnSearchCheckboxIcon: function() {
      RS.Modules.SearchBox.refMpnSearchCheckboxIcon.click(function() {
        var toggleMpnSearchChecked = !RS.Modules.SearchBox.isMpnSearchChecked();

        // BR-858 temporaily remove the storing the MPN tick box in SessionStorage
        // RS.Utils.LocalStorage.setItemInSessionStorage(RS.Modules.SearchBox.MPN_SEARCH_CHECKED, toggleMpnSearchChecked);

        RS.Modules.SearchBox.setMpnSearchCheckbox(toggleMpnSearchChecked);
        RS.Modules.SearchBox.toggleMpnSearchCheckboxIcon();
      });
    },

    initMpnSearch: function() {
      if (RS.Modules.SearchBox.isMpnSearchEnabled()) {
        RS.Modules.SearchBox.refMpnSearchCheckbox = $('#mpnSearchCheckbox');
        RS.Modules.SearchBox.refMpnSearchCheckboxIcon = $('#mpnSearchCheckboxIcon');
        RS.Modules.SearchBox.bindMpnSearchCheckboxIcon();

        // BR-858 temporaily remove the storing the MPN tick box in SessionStorage
        // var fromSessionStorage = RS.Utils.LocalStorage.getItemFromSessionStorage(RS.Modules.SearchBox.MPN_SEARCH_CHECKED);
        // var isMpnSearchChecked = (fromSessionStorage === 'true');
        // if (isMpnSearchChecked) {
        //   RS.Modules.SearchBox.setMpnSearchCheckbox(true);
        //   RS.Modules.SearchBox.toggleMpnSearchCheckboxIcon();
        // }
      }
    },

    isMpnSearchChecked: function() {
      return RS.Modules.SearchBox.isMpnSearchEnabled() && RS.Modules.SearchBox.refMpnSearchCheckbox.is(':checked');
    },

    isMpnSearchEnabled: function() {
      return typeof window.searchConfig !== 'undefined' && typeof window.searchConfig.mpnSearchEnabled !== 'undefined' && window.searchConfig.mpnSearchEnabled;
    },

    setMpnSearchCheckbox: function(mpnSearchChecked) {
      RS.Modules.SearchBox.refMpnSearchCheckbox.prop('checked', mpnSearchChecked);
    },

    toggleMpnSearchCheckboxIcon: function() {
      RS.Modules.SearchBox.refMpnSearchCheckboxIcon.toggleClass('icon-rs_150-checkbox');
      RS.Modules.SearchBox.refMpnSearchCheckboxIcon.toggleClass('icon-rs_151-checkbox_tick');
    },
  };
}());

(function () {
  // Initalise the Check term
  RS.Modules.SearchBox.init('#searchForm', '#searchTerm');
  RS.Modules.SearchBox.initMpnSearch();
}());

/***/ }),

/***/ 324:
/***/ (function(module, exports) {

(function () {

  RS.Modules.Bloomreach = {
    refQuickView: null,
    refClose: null,
    refOverlay: null,

    init: function () {
      this.refQuickView = $('.br-sf-widget-merchant-qv a');
      this.refClose = $('.br-sf-widget-merchant-popup-close a');
      this.refOverlay = $('#overlay');
      this.quickView();
    },

    quickView: function () {
      this.refQuickView.click(function () {
        $('#overlay').addClass('menuOverlay');
      });
      this.refClose.click(function () {
        $('#overlay').removeClass('menuOverlay');
      });
      this.refOverlay.click(function () {
        if (typeof(hideBrRpQv) !== 'undefined') {
          hideBrRpQv();
        }
      });
    },

  };
}());

(function () {
  RS.Modules.Bloomreach.init();
}());


/***/ }),

/***/ 325:
/***/ (function(module, exports) {

/*
 * This JS file, is designed to break the dependency between our "analytics.js" and Ensighten,
 * therefore it provides the following:-
 * 1) a listener for the generic "dataBlockLoadEvent" which triggers an Ensighten specific event to read the new
 *  data block "rs.web.digitalData"
 * 2) a listener for the generic "dataBlockCustomPageDataEvent" which triggers an Ensighten specific event to read
 *  the new event block "rs.web.digitalData.events"
 *
 * This has a dependency on jQuery, and is intended to be used in conjunction with "analytics.js"
 */
RS.Modules.EnsightenAnalytics = (function () {
  /* Initialise */
  function init() {
    if (RS.Modules.EnsightenAnalytics.isBootstrapperAvailable()) {
      var _bootstrapper = window.Bootstrapper || {};
      RS.Modules.EnsightenAnalytics.addEventListeners(_bootstrapper);
    }
  }

  /*
   * Add the generic event listeners
   */
  function addEventListeners(bootstrapper) {
    /* Tell ensighten some data was added */
    $(document).on('dataBlockLoadEvent', function () {
      bootstrapper.ensEvent.trigger('reloadDataBlockEvent');
    });

    /* Tell ensighten a new event was added */
    $(document).on('dataBlockCustomPageDataEvent', function () {
      bootstrapper.ensEvent.trigger('customPageDataEvent');
    });
  }

  /*
   * Check is Bootstrapper is loaded
   */
  function isBootstrapperAvailable() {
    return (typeof Bootstrapper === 'object' && Bootstrapper !== null &&
      Bootstrapper.ensEvent && Bootstrapper.ensEvent.trigger);
  }

  /*
   * Make the following methods externally visible
   */
  return {
    init: init,
    addEventListeners: addEventListeners,
    isBootstrapperAvailable: isBootstrapperAvailable,
  };
})();

(function () {
  RS.Modules.EnsightenAnalytics.init();
}());


/***/ }),

/***/ 326:
/***/ (function(module, exports) {

/*
 * This JS file provides the following:-
 * 1) Add extra runtime data in the "rs.web.digitalData" object such as ecSystemId, search_config, search_keyword
 *    via an Ajax call
 * 2) The ability to publish events into "rs.web.digitalData.events"
 *
 * This has a dependency on jQuery and is intended to be used in conjunction with "ensightenAnalytics.js"
 */

/* eslint-disable */
RS.Modules.Analytics = (function() {
    'use strict';
    var urlCategoryPage = '/web/services/webAnalytics/dynamicData';
    var urlProductPage = '/web/services/webAnalytics/dynamicProductData';
    var urlSearchPage = '/web/services/webAnalytics/dynamicSearchData';
    var urlZeroResultsPage = '/web/services/webAnalytics/dynamicZeroResultsData';
    var urlHomePage = '/web/services/webAnalytics/dynamicHomeData';
    var deferredEventKey = 'RS.Modules.Analytics.deferredEvent';
    var staticPageData = {};

    // N.B. Any changes here will have to be reflected in facetFilters.constants.js eventConstants and
    // in facetfilters.analytics.service.js createAndDispatchApplyFilterEvent function
    var eventConstants = {
        GENERIC_ANALYTICS_EVENT: 'genericAnalyticsEvent'
    };

    /*
     * Initialise the object, to load extra data from the server and add event listeners
     */
    function init() {
        if (RS.Modules.EnsightenAnalytics.isBootstrapperAvailable() && hasStaticData()) {
            /* load data */
            loadDataBlock();
            /* Add event listeners */
            addEventListeners();
        }
    }
    /*
     * Check page has static data
     */
    function hasStaticData() {
        var _pageData = pageData || {};
        return (typeof _pageData.dataBlockVariableValueMap !== 'undefined');
    }

    function loadDataBlock() {
        /* get static page data */
        staticPageData = pageData.dataBlockVariableValueMap;
        /* load customer specific global data on page load */
        /*jshint camelcase: false */
        /*jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
        if (staticPageData.page_type === 'new product') {
            getProdPageData();
        } else if (staticPageData.page_type === 'new tn') {
            getCategoryPageData();
        }  else if (staticPageData.page_type === 'new sr' || staticPageData.page_type === 'new l1' || staticPageData.page_type === 'new l2') {
            getSearchPageData();
        }	else if (staticPageData.page_type === 'new_zr') {
        	getZeroResultsPageData();
        } else if (staticPageData.page_type === 'home page') {
          getHomePageData();
        }
    }

    function getQueryStringJSON() {

        var _queryString = window.location.search,
            _queryStringJSON = '';
        if (_queryString.length > 0) {
            var _queryParams = _queryString.slice(1).split('&'),
                _querObj = {};
            _queryParams.forEach(function(_queryParam) {
                _queryParam = _queryParam.split('=');
                _querObj[_queryParam[0]] = decodeURIComponent(_queryParam[1] || '');
            });
            _queryStringJSON = JSON.parse(JSON.stringify(_querObj));
        }
        return _queryStringJSON;

    }

    function getSearchPageData() {
        RS.Utils.AjaxService.processXHR(urlSearchPage, 'POST', 5000, combineAnalyticsData, getQueryStringJSON());
      }

    function getZeroResultsPageData() {
        RS.Utils.AjaxService.processXHR(urlZeroResultsPage, 'POST', 5000, combineAnalyticsData, getQueryStringJSON());
      }

    function getProdPageData() {
        RS.Utils.AjaxService.processXHR(urlProductPage, 'POST', 5000, combineAnalyticsData, getQueryStringJSON());
    }

    function getHomePageData() {
        RS.Utils.AjaxService.processXHR(urlHomePage, 'POST', 5000, combineAnalyticsData, getQueryStringJSON());
    }
    function getCategoryPageData() {

        urlCategoryPage += '?' + window.location.search.substring(1);
        RS.Utils.AjaxService.processXHR(urlCategoryPage, 'GET', 5000, combineAnalyticsData);
    }

    /* Combine the dynamic data with static data and call ensighten event */
    function combineAnalyticsData(data) {
        $.extend(rs.web.digitalData, data.dataBlockVariableValueMap)
        $(document).trigger('dataBlockLoadEvent');
        publishDeferredEvent();
        // Now Repopulate the Search Term (in the search box)
        RS.Modules.SearchBox.repopulateSearchTerm();
    }

    /*
     * Add listeners for various custom JavaScript events
     */
    function addEventListeners() {
        /* user events on page itself could trigger to reload the global data,
           eventually triggering an event for other tags dependent upon the global data block */
        $(document).on('reloadDataBlockEvent', RS.Modules.Analytics.loadDataBlock);

        /* Publishes Generic analytics Event. */
        $(document).on(eventConstants.GENERIC_ANALYTICS_EVENT, function(event) {
            publishEvent(event.detail.type, event.detail.data);
        });

    }

    /*
     * Create an event object in the rs.web.digitalData.events array
     */
    function publishEvent(evtKey, evtData) {
        rs.web.digitalData.events = rs.web.digitalData.events || [];
        rs.web.digitalData.events.push({
            eventKey: evtKey,
            eventData: evtData,
            eventTimestamp: new Date().toUTCString()
        });
        $(document).trigger('dataBlockCustomPageDataEvent');

    }

    /*
     * Trigger an add to cart event
     */
    function publishAddToCartEvent(productId, quantity, pageName) {
        var eventData = {
            products: [{
                /*jshint camelcase: false */
                /*jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
                cart_action_type: pageName, // We cannot change this as its used for other pages
                orderQuantity: quantity,
                productId: productId
            }]
        };

        publishEvent('addToCartDataBlockEvent', eventData);

    }

    function publishAddToBundle(articleId, quantity, categoryName) {
        var eventData = {
            products: [{
                category: categoryName,
                orderQuantity: quantity,
                productId: articleId
            }]
        };
        publishEvent('bundle.add', eventData);
    }

    function publishRemoveFromBundle(articleId, quantity, categoryName) {
        var eventData = {
                products: [{
                    category: categoryName,
                    orderQuantity: quantity,
                    productId: articleId
                }]
        };
        publishEvent('bundle.remove', eventData);
    }

    /*
     * Trigger an add to cart event
     */
    function publishAddBundleToCartEvent(articles, pageName) {
        var items = [];
        articles.forEach(function(article) {
             var item = {};
             item ["productId"] = article.articleId;
             item ["orderQuantity"] = article.quantity;
             item["cart_action_type"] = pageName;
             items.push(item)
        });
        var eventData = {
            products: items
        };

        publishEvent('addToCartDataBlockEvent', eventData);

    }

    /*
    * Write an event to localstorage (if it's supported) then, when the search result page is loaded the event can be added to the events array see publishDeferredEvent()
    * N.B. "method" and/or "predictiveSearchLink" might be null
    */
    function addDeferredSearchEvent(location, searchTerm, type, predictiveSearchLink) {
        var deferredEvent = JSON.parse(RS.Utils.LocalStorage.getItem(deferredEventKey));
        if (!deferredEvent || deferredEvent.evtKey !== 'searchEvent') { // Don't overwrite an exisitng 'searchEvent'
          addDeferredEvent('searchEvent', {
              location: location,
              predictiveSearchLink: predictiveSearchLink,
              searchTerm: searchTerm,
              type: type || 'keyed',
          });
        }
    }

    /*
    * Add a deferred event to localstorage (if its supported)
    */
    function addDeferredEvent(evtKey, evtData) {
        if (RS.Utils.LocalStorage.isAvailable()) {
            RS.Utils.LocalStorage.setItem(deferredEventKey, JSON.stringify({
                evtKey: evtKey,
                evtData: evtData,
            }));
        }
    }

    /*
    * Add a deferred event to localstorage (if its supported), including a embellishFromTargetPage object.
    * The embellishFromTargetPage contains a targetFieldName & sourceFieldName, and when deferred event is played,
    * a field with the targetFieldName is added (to the evtData) with the value of sourceFieldName from the target page
    */
    function addDeferredEventWithEmbellishment(evtKey, evtData, embellishFromTargetPage) {
      if (RS.Utils.LocalStorage.isAvailable()) {
          RS.Utils.LocalStorage.setItem(deferredEventKey, JSON.stringify({
              evtKey: evtKey,
              evtData: evtData,
              embellishFromTargetPage: embellishFromTargetPage
          }));
      }
    }

    /*
    * Take the deferred event from localstorage and post it into the events array (called from combineAnalyticsData above), adding any embellishment data as appropriate
    */
    function publishDeferredEvent() {
        if (RS.Utils.LocalStorage.isAvailable()) {
            var deferredEvent = JSON.parse(RS.Utils.LocalStorage.getItem(deferredEventKey));
            if (deferredEvent) {
                var eventData = deferredEvent.evtData;
                var embellishedEventData;

                if (deferredEvent.embellishFromTargetPage) {
                  embellishedEventData = addEmbellishment(
                                            deferredEvent.evtData,
                                            deferredEvent.embellishFromTargetPage.sourceFieldName,
                                            deferredEvent.embellishFromTargetPage.targetFieldName);
                }

                publishEvent(deferredEvent.evtKey, embellishedEventData || eventData);
                localStorage.removeItem(deferredEventKey);
            }
        }
    }

    /*
    * Creating a new property called "targetFieldName" on the event data, giving it the value of the "sourceFieldName" property in rs.web.digitalData
    */
    function addEmbellishment(eventData, sourceFieldName, targetFieldName) {
      var sourceFieldValue = rs.web.digitalData[sourceFieldName];
      var embellishedEventData = eventData;
      if (sourceFieldValue) {
        embellishedEventData[targetFieldName] = sourceFieldValue;
      }

      return embellishedEventData;
    }

    /*
     * Make the following methods externally visible
     */
    return {
        addDeferredEventWithEmbellishment: addDeferredEventWithEmbellishment,
        addDeferredSearchEvent: addDeferredSearchEvent,
        init: init,
        publishEvent: publishEvent,
        publishAddToCartEvent: publishAddToCartEvent,
        publishAddBundleToCartEvent: publishAddBundleToCartEvent,
        publishAddToBundle: publishAddToBundle,
        publishRemoveFromBundle: publishRemoveFromBundle,
    };

})();

(function() {
    'use strict';
    RS.Modules.Analytics.init();
}());


/***/ }),

/***/ 327:
/***/ (function(module, exports) {

(function() {

  RS.Modules.PredictiveSearch = {

    config: null,
    timeoutId: null,
    catreqId: null,
    prodreqId: null,
    topCategories: {},
    refSearchForm: null,
    refSearchTerm: null,
    refResultProd: null,
    refResultHint: null,
    refPredictiveSearch: null,
    refSearchHint: null,
    predictivesearchLink: null,
    topCatName: null,


    keysearch: function() {
      var psearch = RS.Modules.PredictiveSearch;

      psearch.refSearchTerm.keydown(function(e) {

        // abort Ajax call
        if(RS.Modules.PredictiveSearch.catreqId){
          RS.Modules.PredictiveSearch.catreqId.abort();
        }
        if(RS.Modules.PredictiveSearch.prodreqId){
          RS.Modules.PredictiveSearch.prodreqId.abort();
        }

        // clear timer
        clearTimeout(RS.Modules.PredictiveSearch.timeoutId);

        var escapeCode = e.charCode || e.keyCode;
        RS.Modules.PredictiveSearch.keyboardNavigation(escapeCode);

      });

      psearch.refSearchTerm.focus(function(e) {
        // text style for differences in strut and seam headers
        $(this).css('color', '#000000');
      });

      psearch.refSearchTerm.keyup(function(e) {
        if (!RS.Modules.SearchHistory.isSearchHistoryItemHovered()) { // Don't trigger when user presses enter on Search History item
          if (e.keyCode == 13){
            RS.Modules.PredictiveSearch.search();
          }
          else{
            RS.Modules.PredictiveSearch.timeoutId = setTimeout(RS.Modules.PredictiveSearch.search, RS.Modules.PredictiveSearch.maxDelay);
          }
        }
      });

      psearch.refSearchForm.mouseleave(function() {
        RS.Modules.PredictiveSearch.refPredictiveSearch.hide();
        RS.Modules.PredictiveSearch.unbindResultListeners();
      });

      psearch.refSearchForm.focus(function() {
        RS.Modules.PredictiveSearch.search()
      })

    },

    trimSpaces: function(sreachString){
      if (sreachString != null) {
        sreachString = sreachString.replace ( /^\s+/g, "" );// strip leading
        sreachString = sreachString.replace ( /\s+$/g, "" );// strip trailing
        sreachString = sreachString.replace ( /\s+/g, " " );// replace multiple with single
        }
      return sreachString;
    },

    getSearchCriteria: function(locale, advancedSearch) {
        var criteria = '&locale=' + locale + '&advancedPredictiveSearchEnabled=' + advancedSearch;

        return (RS.Modules.PredictiveSearch.config.restrictedCustomer) ?  criteria += "&soldTo=" + RS.Modules.PredictiveSearch.config.restrictedCustomer : criteria;
    },

    getTopProductsURL: function(locale, categoryURL) {
        var url ='/predictivesearch/top-products/locales/' + locale + '/categories' + categoryURL;

        return (RS.Modules.PredictiveSearch.config.restrictedCustomer) ?  url += "?soldTo=" + RS.Modules.PredictiveSearch.config.restrictedCustomer : url;
    },
    search: function() {
      var url = '/predictivesearch/catSearch?searchTerm=', type = 'GET', criteria, searchTerm;

      criteria = RS.Modules.PredictiveSearch.getSearchCriteria(RS.Modules.PredictiveSearch.config.srchLocale, RS.Modules.PredictiveSearch.config.advsrchEnabled);

      searchTerm = RS.Modules.PredictiveSearch.trimSpaces(RS.Modules.PredictiveSearch.refSearchTerm.val());

      RS.Modules.PredictiveSearch.refPredictiveSearch.hide();

      // no search less than 3 characters
      if (typeof RS.Modules.PredictiveSearch.refSearchTerm === 'undefined') {
        return;
      }

      if (searchTerm.length <= RS.Modules.PredictiveSearch.config.searchTermMinLength) {
        return;
      }

      // return last search if it is the same
      if (RS.Modules.PredictiveSearch.refSearchTerm.data('searchTerm') === searchTerm) {
        RS.Modules.PredictiveSearch.refPredictiveSearch.show(true);
        return;
      }

      RS.Modules.PredictiveSearch.catreqId = RS.Utils.AjaxService.processXHR(url + searchTerm + criteria, type, 5000, RS.Modules.PredictiveSearch.updateSearchResult);

    },

    updateSearchResult: function(resultData) {
      var resultFormatted = '';
      var formattedItem = '';
      var elementNo = 0;

      // store search term
      RS.Modules.PredictiveSearch.refSearchTerm.data('searchTerm', RS.Modules.PredictiveSearch.trimSpaces(RS.Modules.PredictiveSearch.refSearchTerm.val()));

      // reset search result
      RS.Modules.PredictiveSearch.unbindResultListeners();
      RS.Modules.PredictiveSearch.refResultHint.html('');
      RS.Modules.PredictiveSearch.refResultProd.html('');

      // no data
      if (!resultData) {
        return;
      }
      resultData = JSON.parse(resultData);

      for (var group in resultData) {
        if (resultData.hasOwnProperty(group)) {
          resultFormatted = resultFormatted + '<li class="section-title">' + group + '</li>';
          var items = resultData[group];
          for (var item in items) {
            var url = items[item];
            if(url.indexOf('/web') === -1){
              if(url.indexOf("?") > -1){
                url = '/web' + url + '&sra=p';
              } else {
                url = '/web' + url + '?sra=p';
              }
            }
            var catName = item.replace(/\'/g, "");
            if (items[item].indexOf("/c/") === 4) {
              if (elementNo === 0) {
                //first element
                RS.Modules.PredictiveSearch.loadTopCategory(url, catName);
              }
            }
            formattedItem = item.replace(new RegExp('(' + RS.Modules.PredictiveSearch.refSearchTerm.val() + ')', 'gi'), "<b>$1</b>");
            resultFormatted = resultFormatted + "<li><a data-category='" + catName + "' onmouseenter='RS.Modules.PredictiveSearch.getTopProducts(this)' id=" + (elementNo++) + " href='" + url + "'>" + formattedItem + "</a></li>";
          }

        }
      }

      //update html
      RS.Modules.PredictiveSearch.refPredictiveSearch.show(true);
      RS.Modules.PredictiveSearch.refResultHint.show(true).html(resultFormatted);
      RS.Modules.PredictiveSearch.bindResultListeners();
    },

    loadTopCategory: function(catURL, catName) {
      var type = 'GET';

      RS.Modules.PredictiveSearch.unbindTopProductListeners();

      if (catName.lastIndexOf('>') >= 0) {
        RS.Modules.PredictiveSearch.topCatName = catName.substring(catName.lastIndexOf('>')+1);
      } else {
        RS.Modules.PredictiveSearch.topCatName = catName;
      }

      // locale from system var
      var url = RS.Modules.PredictiveSearch.getTopProductsURL(RS.Modules.PredictiveSearch.config.srchLocale, catURL.replace(/\/web|\?sra=p/g, ""));

      // no advanced search enabled
      if ( !RS.Modules.PredictiveSearch.config.advsrchEnabled ){
        return;
      }

      // last cat name
      if (catName.lastIndexOf(">") >= 0) {
        catName = catName.substring(catName.lastIndexOf(">") + 1);
      }

      // pick from cache if available
      if (RS.Modules.PredictiveSearch.topCategories[url] != null) {
        RS.Modules.PredictiveSearch.refResultProd.show(true).html(RS.Modules.PredictiveSearch.topCategories[url]);
        RS.Modules.PredictiveSearch.bindTopProductListeners();
        return;
      }

      RS.Modules.PredictiveSearch.prodreqId = RS.Utils.AjaxService.processXHR(url, type, 5000, RS.Modules.PredictiveSearch.updateAdvancedSearchResult);
    },

    unbindResultListeners: function() {
      $('.search-hint li a[data-category]').off('click');
    },

    bindResultListeners: function() {
      $('.search-hint').on('click', 'li a[data-category]', function(event) {
        var category = $(event.currentTarget).data('category');
        var linkHref = $(event.currentTarget).prop('href');

        // Don't add events for Brand links as the Brand page is old so won't process it
        if(linkHref && linkHref.indexOf('/b/') < 0) {
          RS.Modules.Analytics.addDeferredSearchEvent('header', category, 'Predictive', linkHref);
        }
      });
    },

    unbindTopProductListeners: function() {
      $('.search-prod li a').off('click');
    },

    bindTopProductListeners: function() {
      $('.search-prod').on('click', 'li a', function(event) {
        var productName = $(event.currentTarget).data('name');
        var linkHref = $(event.currentTarget).prop('href');
        RS.Modules.Analytics.addDeferredSearchEvent('header', productName, 'Predictive', linkHref);
      });
    },

    updateAdvancedSearchResult: function(resultData) {
      var prodList = '<li class="prod-cat">' + RS.Modules.PredictiveSearch.config.tpTitle + ' ' + RS.Modules.PredictiveSearch.config.tpSubTitle + ' ' + RS.Modules.PredictiveSearch.topCatName + '</li>';
      var catURL = this.url;

      // no data
      if (!resultData || !resultData.hasOwnProperty('products')) {
        return;
      }

      // build advanced search
      for (var i = 0; i < resultData.products.length; i++) {
        prodList = prodList + '<li><a data-name="'+ resultData.products[i].longDescription +'" href="/web/p/products/' + resultData.products[i].productNumber +
        '/?tpr=' + (i + 1) + '"><div class="prod-img"><img src="' + resultData.products[i].imagePath +
        '"></div><div class="prod-name">' + resultData.products[i].longDescription +
        '<div class="prod-brand">' + resultData.products[i].brandName + '</div></div></a></li>';
      }

      // store the result
      RS.Modules.PredictiveSearch.topCategories[catURL] = prodList;
      RS.Modules.PredictiveSearch.refResultProd.show(true).html(prodList);
      RS.Modules.PredictiveSearch.bindTopProductListeners();
    },

    getTopProducts: function(elmAnchor) {
      var catURL = elmAnchor.getAttribute('href');
      var catName = elmAnchor.getAttribute('data-category');
      if (catURL.indexOf("/c/") > -1) {
        // only if it is a category
        if (catName.lastIndexOf(">") >= 0) {
          catName = catName.substring(catName.lastIndexOf(">") + 1);
        }
        // call the top category
        RS.Modules.PredictiveSearch.loadTopCategory(catURL, catName);
      } else {
        // no category
        RS.Modules.PredictiveSearch.refResultProd.hide();
      }
    },

    keyboardNavigation: function(keyCode) {
      var currentId = 0;

      if ($('.predictive-search').is(":hidden")) {
        return;
      }

      switch (keyCode) {

        case 27:
          // esc key
          RS.Modules.PredictiveSearch.refSearchTerm.val('');
          break;

        case 38:
          // up arrow
          if ($('.search-hint li .textRed').length > 0) {
            currentId = parseInt($('.search-hint li .textRed')[0].id);
            //unset active link
            $('.search-hint li #' + currentId).toggleClass('textRed');
            currentId--;
            //set active link
            $('.search-hint li #' + currentId).toggleClass('textRed');
            RS.Modules.PredictiveSearch.predictivesearchLink = $('.search-hint li #' + currentId)[0].href;
          }
          break;

        case 40:
          // down arrow
          if ($('.search-hint li .textRed').length == 0) {
            // start with first
            $('.search-hint li #0').toggleClass('textRed');
          } else {
            currentId = parseInt($('.search-hint li .textRed')[0].id);
            //unset active link
            $('.search-hint li #' + currentId).toggleClass('textRed');
            currentId++;
            //set active link
            $('.search-hint li #' + currentId).toggleClass('textRed');
            RS.Modules.PredictiveSearch.predictivesearchLink = $('.search-hint li #' + currentId)[0].href;
          }
          break;

        case 13:
          //enter key
          window.location.href = RS.Modules.PredictiveSearch.predictivesearchLink;
          break;

      }

    },

    init: function() {

      var _obj = RS.Modules.PredictiveSearch;
      // only if search config exists
      if (typeof searchConfig !== 'undefined') {
        _obj.refSearchForm = $('#searchForm');
        _obj.refSearchTerm = $('#searchTerm');
        _obj.refResultProd = $('#js-search-prod');
        _obj.refResultHint = $('#js-search-hint');
        _obj.refPredictiveSearch = $('#js-predictive-search');
        _obj.refSearchHint = $('#js-search-hint');
        _obj.config = searchConfig;
        RS.Modules.PredictiveSearch.keysearch();
      }

    }
  }

}());

(function() {
  //Initalise the Check term
  RS.Modules.PredictiveSearch.init();
}());

/***/ }),

/***/ 328:
/***/ (function(module, exports) {

(function () {
  /* eslint-disable */
  RS.Modules.SearchHistory = {
    SEARCH_HISTORY_KEY: 'RS.Modules.SearchHistory.searchTerms',
    refSearchForm: null,
    refSearchHistory: null,
    refSearchHistoryList: null,
    refSearchTerm: null,
    predictiveSearchTermMinLength: null,

    isMpnSearch: function() {
      var isMpnSearch = (((window.rs || {}).web || {}).digitalData || {}).search_search_type || '';
      return isMpnSearch === 'MPN';
    },

    addSearchTermToHistory: function () {
      // BR-858 temporaily remove the storing the MPN tick box in SessionStorage
      var isMpnSearchChecked = RS.Modules.SearchHistory.isMpnSearch(); // RS.Modules.SearchBox.isMpnSearchChecked();
      if (isMpnSearchChecked || !(RS.Modules.SearchHistory.isSearchHistoryEnabled() && RS.Modules.SearchHistory.shouldSearchTermBeSaved())) {
        return;
      }

      var searchTerm = window.searchHistory.searchTermToAdd;

      var existingSearchHistory = RS.Modules.SearchHistory.getSearchHistoryFromLocalStorage();

      var existingSearchTermKey = RS.Modules.SearchHistory.getSearchTermKeyFromHistory(existingSearchHistory, searchTerm);
      if (existingSearchTermKey) {
        delete existingSearchHistory[existingSearchTermKey];
      }

      existingSearchHistory = RS.Modules.SearchHistory.trimHistoryList(existingSearchHistory);
      existingSearchHistory[RS.Modules.SearchHistory.getTimestamp()] = searchTerm;
      RS.Utils.LocalStorage.setItem(RS.Modules.SearchHistory.SEARCH_HISTORY_KEY, JSON.stringify(existingSearchHistory));
    },

    bindListeners: function() {
      RS.Modules.SearchHistory.refSearchForm.mouseleave(function() {
        RS.Modules.SearchHistory.hideSearchHistory();
      });

      RS.Modules.SearchHistory.refSearchTerm.keydown(function(e) {
        RS.Modules.SearchHistory.keyboardNavigation(e);
      });

      RS.Modules.SearchHistory.refSearchTerm.keyup(function(e) {
        var escapeCode = e.charCode || e.keyCode;
        if (escapeCode !== 38 && escapeCode !== 40) { // Not up/down arrow keys
          RS.Modules.SearchHistory.showOrHideSearchHistory();
        }
      });

      RS.Modules.SearchHistory.refSearchTerm.focus(function() {
        RS.Modules.SearchHistory.showOrHideSearchHistory()
      })
    },

    executeSearchForItem: function(keyToSearch) {
      var existingSearchHistory = RS.Modules.SearchHistory.getSearchHistoryFromLocalStorage();
      var searchTerm = existingSearchHistory[keyToSearch];
      RS.Modules.Analytics.addDeferredSearchEvent('header', searchTerm, 'searchHistory');
      RS.Modules.SearchHistory.refSearchTerm.val(searchTerm);
      RS.Modules.SearchHistory.refSearchForm.submit();
    },

    getReversedListOfKeys: function(searchHistory) {
      var keys;
      if (searchHistory) {
        keys = Object.keys(searchHistory).reverse();
      }
      return keys;
    },

    getSearchHistoryFromLocalStorage: function() {
      var existingSearchHistory = RS.Utils.LocalStorage.getItemWithoutExpiry(RS.Modules.SearchHistory.SEARCH_HISTORY_KEY);
      return existingSearchHistory ? JSON.parse(existingSearchHistory) : {};
    },

    getSearchHistory: function() {
      if (!RS.Modules.SearchHistory.isSearchHistoryEnabled()) {
        return null;
      }

      var searchHistory = RS.Modules.SearchHistory.getSearchHistoryFromLocalStorage();

      var searchHistoryLastestFirst = [];
      if (searchHistory) {
        var searchHistoryReversedKeys = Object.keys(searchHistory).reverse();

        for (idx in searchHistoryReversedKeys) {
          var currentKey = searchHistoryReversedKeys[idx];
          var listItem = '<li data-seq="' + idx +'" data-key="'+ currentKey +'" class="search-history-item">'
              + '<span class="search-history-item-term">'+ searchHistory[currentKey] +'</span>'
              + '<i class="search-history-item-delete icon-rs_23-cross"></i>'
              + '</li>';
          searchHistoryLastestFirst.push(listItem);
        }
      }

      return searchHistoryLastestFirst;
    },

    getSearchTermKeyFromHistory: function(searchHistory, term) {
      var lcTerm = term.toLowerCase();
      var searchHistoryKeys = Object.keys(searchHistory);

      for (idx in searchHistoryKeys) {
        var currentKey = searchHistoryKeys[idx];
        var currentSearchTerm = searchHistory[currentKey].toLowerCase();

        if (currentSearchTerm === lcTerm) {
          return currentKey;
        }
      }

      return;
    },

    getTimestamp: function() {
      return Math.floor(Date.now() / 1000);
    },

    hideSearchHistory: function() {
      $('.search-history-item-delete').off('click');
      $('.search-history-item-term').off('click');
      $('.search-history-item.hovered').removeClass('hovered');
      RS.Modules.SearchHistory.refSearchHistory.hide();
    },

    init: function() {
      // Read the predictive search term minimum length, becuase the search history should is shown before the predictive search results start
      RS.Modules.SearchHistory.predictiveSearchTermMinLength = (((RS.Modules || {}).PredictiveSearch || {}).config || {}).searchTermMinLength || 2;

      RS.Modules.SearchHistory.refSearchHistory = $('#js-search-history');
      RS.Modules.SearchHistory.refSearchHistoryList = $('#js-search-history-list');
      RS.Modules.SearchHistory.refSearchForm = $('#searchForm');
      RS.Modules.SearchHistory.refSearchTerm = $('#searchTerm');

      RS.Modules.SearchHistory.bindListeners();
      RS.Modules.SearchHistory.addSearchTermToHistory();
    },

    isSearchHistoryEnabled: function() {
      return typeof window.searchHistory !== 'undefined' && typeof window.searchHistory.enabled !== 'undefined' && window.searchHistory.enabled && RS.Utils.LocalStorage.isAvailable();
    },

    isSearchHistoryItemHovered: function() {
      return $('.search-history-item.hovered').length;
    },

    keyboardNavigation: function(event) {
      var currentSeq = 0;
      var keyCode = event.charCode || event.keyCode;

      if ($('.search-history').is(":hidden")) {
        return;
      }

      switch (keyCode) {
        case 38:
        // up arrow
        if (RS.Modules.SearchHistory.isSearchHistoryItemHovered()) {
          currentSeq = parseInt($('.search-history-item.hovered').data('seq'));
          //unset active link
          $('.search-history-list li[data-seq="' + currentSeq + '"]').removeClass('hovered');
          if (currentSeq > 0) {
            currentSeq--;
            //set active link
            $('.search-history-list li[data-seq="' + currentSeq + '"]').addClass('hovered');
          }
        }
        break;

        case 40:
        // down arrow
        if (!RS.Modules.SearchHistory.isSearchHistoryItemHovered()) {
          // start with first
          $('.search-history-list li[data-seq="0"]').addClass('hovered');
        } else {
          currentSeq = parseInt($('.search-history-item.hovered').data('seq'));

          if ($('.search-history-list li[data-seq="' + (currentSeq + 1) + '"]').length) { // don't allow the user to go beyond the last search term in the list
            //unset active link
            $('.search-history-item.hovered').removeClass('hovered');
            currentSeq++;
            //set active link
            $('.search-history-list li[data-seq="' + currentSeq + '"]').addClass('hovered');
          }
        }

        break;

        case 13:
        //enter key
        if (RS.Modules.SearchHistory.isSearchHistoryItemHovered()) {
          var keyToSearch = $('.search-history-item.hovered').data('key');
          RS.Modules.SearchHistory.executeSearchForItem(keyToSearch);
        }
      };
    },

    removeSearchTermFromHistory: function(keyToRemove) {
      var existingSearchHistory = RS.Modules.SearchHistory.getSearchHistoryFromLocalStorage();
      delete existingSearchHistory[keyToRemove];

      RS.Utils.LocalStorage.setItem(RS.Modules.SearchHistory.SEARCH_HISTORY_KEY, JSON.stringify(existingSearchHistory));

      $('li[data-key="'+ keyToRemove +'"]').hide();

      if (Object.keys(existingSearchHistory).length === 0) {
        RS.Modules.SearchHistory.hideSearchHistory();
      }
    },

    shouldSearchTermBeSaved: function() {
      return typeof window.searchHistory !== 'undefined'
            && typeof window.searchHistory.searchTermToAdd !== 'undefined';
    },

    showOrHideSearchHistory: function() {
      var searchTerm = RS.Modules.SearchHistory.trimSpaces(RS.Modules.SearchHistory.refSearchTerm.val());
      var isMpnSearchChecked = RS.Modules.SearchBox.isMpnSearchChecked();
      // The search history is shown before the predictive search results, predictive search only starts when the user enters 3 or more chars
      if (!isMpnSearchChecked && (searchTerm === 'undefined' || searchTerm.length <= RS.Modules.SearchHistory.predictiveSearchTermMinLength)) {
        var searchHistoryList = RS.Modules.SearchHistory.getSearchHistory();
        if (searchHistoryList !== null && searchHistoryList.length) {
          RS.Modules.SearchHistory.refSearchHistoryList.html(searchHistoryList);

          $('.search-history-item-delete').on('click', function(event) {
            var keyToRemove = $(event.target).parent().data('key');
            RS.Modules.SearchHistory.removeSearchTermFromHistory(keyToRemove);
          });

          $('.search-history-item-term').on('click', function(event) {
            var keyToSearch = $(event.target).parent().data('key');
            RS.Modules.SearchHistory.executeSearchForItem(keyToSearch);
          });

          RS.Modules.SearchHistory.refSearchHistory.show();
          return;
        }
      }

      RS.Modules.SearchHistory.hideSearchHistory();
    },

    trimHistoryList: function(searchHistory) {
      var trimmedSearchHistory = searchHistory;
      var shReversedKeys = this.getReversedListOfKeys(searchHistory);

      if (shReversedKeys.length === 5) {
        delete trimmedSearchHistory[shReversedKeys[4]];
      }

      return trimmedSearchHistory;
    },

    trimSpaces: function(searchTerm){
      if (searchTerm != null) {
        searchTerm = searchTerm.replace ( /^\s+/g, "" );// strip leading
        searchTerm = searchTerm.replace ( /\s+$/g, "" );// strip trailing
        searchTerm = searchTerm.replace ( /\s+/g, " " );// replace multiple with single
      }

      return searchTerm;
    },
  };
}());

(function () {
  RS.Modules.SearchHistory.init();
}());


/***/ }),

/***/ 329:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 60:
/***/ (function(module, exports) {

//reusable cookies functionality
(function () {
  RS.Utils.Cookies = {
    reflnkViewDesktop: null,

    // set cookie name value expiry days
    setCookie: function (name, value, days) {
      var expires = '';
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toGMTString();
      }
      document.cookie = name + '=' + value + expires + '; path=/';
    },

    // get cookie cookie name
    getCookie: function (cname) {
      var _name = cname + '=';
      var _ca = document.cookie.split(';');
      var _cookVal = null;
      for (var i = 0; i < _ca.length; i++) {
        var c = _ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(_name) === 0) {
          _cookVal = c.substring(_name.length, c.length);
        }
      }
      return _cookVal;
    },
  };
}());


/***/ })

/******/ });


// WEBPACK FOOTER //
// universalHeader.min.js